import {useEffect, useState} from 'react'
import {Banner} from '@primer/react'
import safeStorage from '@github-ui/safe-storage'

const DISMISSED_STORAGE_KEY = 'pr-overview:early-development-banner:dismissed'
const DISMISS_TTL_MS = 48 * 60 * 60 * 1000 // 48 hours

const storage = safeStorage('localStorage', {throwQuotaErrorsOnSet: false, ttl: DISMISS_TTL_MS})

export function EarlyDevelopmentBanner() {
  const [isDismissed, setIsDismissed] = useState(true)

  useEffect(() => {
    if (!storage.getItem(DISMISSED_STORAGE_KEY)) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setIsDismissed(false)
    }
  }, [])

  if (isDismissed) {
    return null
  }

  const handleDismiss = () => {
    storage.setItem(DISMISSED_STORAGE_KEY, '1')
    setIsDismissed(true)
  }

  return (
    <Banner
      actionsLayout="inline"
      onDismiss={handleDismiss}
      primaryAction={
        <Banner.PrimaryAction
          as="a"
          href="https://gh.io/pr-overview-feedback"
          target="_blank"
          rel="noopener noreferrer"
        >
          Feedback
        </Banner.PrimaryAction>
      }
      secondaryAction={
        <Banner.SecondaryAction as="a" href="https://gh.io/pr-overview" target="_blank" rel="noopener noreferrer">
          Learn more
        </Banner.SecondaryAction>
      }
      title="This page is in early development and still evolving. Your feedback is important."
      variant="info"
    />
  )
}
